import { render, staticRenderFns } from "./complist.vue?vue&type=template&id=c382ecb4&scoped=true&"
import script from "./complist.vue?vue&type=script&lang=js&"
export * from "./complist.vue?vue&type=script&lang=js&"
import style0 from "./complist.vue?vue&type=style&index=0&id=c382ecb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c382ecb4",
  null
  
)

export default component.exports